import {
  ArticleCell,
  PriceCell,
  AmountCell,
} from 'components/gifts-table/Cells';

export const columns = [
  {
    label: { label: 'ARTÍCULO' },
    field: 'article',
    align: 'left',
    variant: 'primary',
    weight: 'bold',
    renderer: (props) => <ArticleCell {...props} {...props.article} />,
  },
  {
    label: 'PRECIO',
    field: 'price',
    align: 'center',
    renderer: (props) => <PriceCell {...props} />,
  },
  {
    label: 'CANTIDAD',
    field: 'amount',
    align: 'center',
    renderer: (props) => <AmountCell {...props} />,
  },
];
